import Select from 'react-select';
import classes from '../components/FormElements/Element.module.scss';

const YearFilter = (props) => {
  const { onFilterChange } = props;

  const currentYear = new Date().getFullYear();

  let startYear = 2024; // you can change this if needed
  let yrArr = [];

  for (let yr = currentYear; yr >= startYear; yr--) {
    yrArr.push({ value: yr, label: yr });
  }

  const extOptions = [{ value: 'all', label: 'All' }];

  const filterOptions = yrArr.concat(extOptions);

  return (
    <div
      className="d-inline-block eep_select_div"
      style={{ zIndex: 100 }}
    >
      <Select
        options={filterOptions}
        placeholder=""
        classNamePrefix="eep_select_common contact_number"
        className={`form-control py-0 c1 basic-single ${classes.formControl}`}
        menuPlacement="bottom"
        onChange={(event) => onFilterChange(event)}
        defaultValue={yrArr[0]} // current year selected
      />
    </div>
  );
};

export default YearFilter;
